'use strict'

class CookieMessage {
  constructor (wrapper) {
    this.cookies = wrapper
    this.closing = wrapper.querySelectorAll('.cookie-message__close')

    this.createGlobalEventHandlers()
    this.init()
  }

  isProductView () {
    return document.querySelector('body').classList.contains('catalog-product-view')
  }

  resetZopimOffset () {
    this.zopimButton.setOffsetVerticalMobile(0)
    this.zopimButton.setOffsetVertical(0)
  }

  setListeners () {
    this.closing.forEach(el => {
      el.addEventListener('click', this.closeBar)
    })

    const waitForZopim = setInterval(() => {
      const zopim = window.$zopim

      if (zopim) {
        this.zopimButton = zopim.livechat.button
        window.addEventListener('scroll', this.onScrollEvent)
        clearInterval(waitForZopim)
      }
    }, 100)
  }

  createGlobalEventHandlers () {
    this.closeBar = (el) => {
      const cookieMessage = el.currentTarget.parentElement.parentElement
      const dataType = cookieMessage.dataset.type

      cookieMessage.classList.remove('cookie-message--open')
      localStorage.setItem(dataType, 'closed')
      window.removeEventListener('scroll', this.onScrollEvent)
      this.resetZopimOffset()
    }

    this.onScrollEvent = () => {
      const { scrollHeight, scrollTop, clientHeight } = document.documentElement

      // Detect if browser window is scrolled to bottom
      if (scrollHeight - scrollTop === clientHeight) {
        this.zopimButton.setOffsetVerticalMobile(125)
        this.zopimButton.setOffsetVertical(50)
      } else if (scrollHeight - scrollTop < clientHeight + 50) {
        this.resetZopimOffset()
      }
    }
  }

  init () {
    // Display message if it wasn't closed before
    const dataType = this.cookies.dataset.type

    if (localStorage.getItem(dataType) !== 'closed') {
      this.cookies.classList.add('cookie-message--open')
      !this.isProductView() && this.setListeners()
    }
  }
}

define(() => (config, element) => {
  new CookieMessage(element)
})
